import { RestaurantsListInput } from "./RestaurantListInput";

export default RestaurantsListInput;
